import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { MediumText } from "../typography";
import { Arrow } from "./dropdown";
import { useEffect, useRef, useState } from "react";

import arrowDownIcon from "../../assets/images/icons/arrow-down-icon.svg";
import arrowUpIcon from "../../assets/images/icons/arrow-up-icon.svg";
import toast from "react-hot-toast";
import CustomToast from "./custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { useNavigate } from "react-router-dom";

const AccountItem = ({
  item,
  isChangedFields,
}: {
  item: any;
  isChangedFields: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState("0px");
  const navigate = useNavigate();
  const location = window.location.pathname;

  useEffect(() => {
    if (contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    }
  }, []);

  const toggle = () => {
    if (!isOpen) {
      setHeight(`${contentRef.current?.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
    setIsOpen(!isOpen);
  };

  return (
    <AccountItemStyle>
      <span
        data-type="title"
        className="d-flex align-items-center gap-2"
        onClick={toggle}
      >
        <MediumText>{item.part}</MediumText>
        <Arrow iconUrl={isOpen ? arrowDownIcon : arrowUpIcon}></Arrow>
      </span>

      <div
        ref={contentRef}
        style={{
          maxHeight: height,
          opacity: isOpen ? 1 : 0,
          transition: "all 0.4s ease",
          overflow: "hidden",
        }}
        data-open={isOpen}
      >
        {item.items.map((subitem: any) => (
          <span
            key={subitem.title}
            data-is_active={location.includes(subitem.path)}
            onClick={() => {
              if (isChangedFields) {
                toast((t) => {
                  return (
                    <CustomToast
                      t={t}
                      type={ToastTypeEnum.WARNING}
                      text={"Спочатку збережіть змінені дані."}
                    />
                  );
                });
                return;
              }

              navigate(subitem.path);
            }}
          >
            <img src={subitem.icon} alt={subitem.title} />
            <MediumText>{subitem.title}</MediumText>
          </span>
        ))}
      </div>
    </AccountItemStyle>
  );
};

export default AccountItem;

const AccountItemStyle = styled.div`
  cursor: pointer;
  span {
    &[data-type="title"] {
      padding: 4px 24px;
    }
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    img {
      width: 26px;
      height: 26px;
    }
    padding: 4px 0px;
    span {
      transition: all 0.15s ease;
      padding: 8px 40px;
      display: flex;
      align-items: center;
      gap: 12px;
      background-color: transparent;

      &[data-is_active="true"],
      &:hover {
        background-color: ${COLORS.gray};
      }
    }

    &[data-open="false"] {
      overflow: hidden;
    }

    &[data-open="true"] {
      transition: all 0.4s ease;
    }
  }
`;
